async function CustomerSave (customerid, customername, customerabbr, address, city, stateid, postalcode, modifiedbyid, deleted) {

    if (
        customername.length > 0 && 
        customerabbr.length > 0 && 
        address.length > 0 && 
        city.length > 0 && 
        stateid.length > 0 && 
        postalcode.length > 0 && 
        modifiedbyid.length > 0 && 
        deleted.length > 0 
    ) {

            let response;

            response = await fetch ("https://api.cssi.co/query", {
                method: "POST",
                body: JSON.stringify({
                    "sp": "58", 
                    "parameters": {
                        "@CustomerId": customerid,
                        "@CustomerName": customername,
                        "@CustomerAbbr": customerabbr,
                        "@Address": address,
                        "@City": city,
                        "@StateId": stateid,
                        "@PostalCode": postalcode,
                        "@ModifiedById": modifiedbyid,
                        "@Deleted": deleted
                    },
                    "servername": "Compass-Svr3\\EXACTSQLEXPRESS", 
                    "databasename": "WebApps", 
                    "continuingfunction": null,
                    "noresults": false, 
                    "args": null
                })
            })
            .then(response => {
                return response.json();
            })
            .then((data) => {
                if (JSON.parse(data.payload).error.length > 0) {            
                    throw Error(JSON.parse(data.payload).error);
                }
                else {
                    response = JSON.parse(data.payload).data; 
                }
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return response;

    }
}
 
export default CustomerSave;